import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import VIPExperience from "@/pages/VIPExperience";
import Contact from "@/pages/Contact";
import Appointments from "@/pages/Appointments";
import Testimonials from "@/pages/Testimonials";

// Layout
import Layout from "@/components/Layout";

function App() {
  return (
    <div className="min-h-screen bg-vip-black">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/vip-experience" element={<VIPExperience />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/testimonials" element={<Testimonials />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#FFFFFF',
          },
        }}
      />
    </div>
  );
}

export default App;
